import { createSlice } from '@reduxjs/toolkit';
import { IResourceSkill } from '../../../../dto';
import { setResourceSkill } from '../actions';
import { MN_RESOURCE_SKILLS, TYPE_ELEMENT } from '../../../../common';

export interface ResourceSkillState {
  data: IResourceSkill | null;
  loading: boolean;
  error: string | null;
}

const initialState: ResourceSkillState = {
  data: null,
  loading: false,
  error: null,
};

export const resourceSkillSlice = createSlice({
  name: `${MN_RESOURCE_SKILLS}/${TYPE_ELEMENT}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setResourceSkill, (state, { payload }) => {
      state.data = payload;
    });
  },
});
